import React from "react";
import { DataGrid } from "@material-ui/data-grid";
import { Typography, Grid, Avatar } from "@material-ui/core";
import { connect } from "react-redux";
import OrderDetails from "../orderDetails/OrderDetails";
import { useTablesStyle } from "../../../styles/tableStyle";
import {
  searchActiveOrders,
  clearSearch,
} from "../../../redux/General/generalActions";
// import { getActive_Ready_Orders } from "../../../redux/Orders/ordersActions";
import NoRowsMessage from "../../../components/NoRowsMessage";
import CustomLoading from "../../../components/CustomLoading";
import Store from "../../../redux/Store";
import {
  findActiveOrders,
  // set_active_ready_orders_Length,
  set_Refresh,
} from "../../../redux/Orders/OrderActionCreators";

const OrdersTable = ({ activeOrders, searchReducer, loading, refresh }) => {
  React.useLayoutEffect(() => {
    Store.dispatch(set_Refresh(refresh + 1));
    // eslint-disable-next-line
  }, []);
  const [orders, set_orders] = React.useState([]);
  React.useEffect(() => {
    return () => {
      clearSearch();
      Store.dispatch(findActiveOrders({ data: [] }));
    };
  }, []);
  const classes = useTablesStyle();

  React.useEffect(() => {
    const d = searchActiveOrders(activeOrders.data, searchReducer);
    set_orders(
      d.sort((a, b) => {
        if (a.immediate_delivery || b.immediate_delivery) return true;
        return false;
      })
    );
  }, [activeOrders.data, searchReducer]);

  const customer_header_list = [
    {
      field: "number",
      headerName: "شماره سفارش",
      flex: 0.4,
      headerAlign: "center",
      align: "center",

      renderCell: (value) => (
        <OrderDetails
          rowValue={value.row.number}
          orderId={value.row.id}
          position="number"
        />
      ),
    },
    {
      field: "price",
      headerName: "هزینه کل",
      flex: 0.4,
      headerAlign: "center",
      align: "center",

      renderCell: (value) => (
        <Typography variant="body2">{value.value.toLocaleString()}</Typography>
      ),
    },

    {
      field: "qtty",
      headerName: "تعداد فایل",
      headerAlign: "center",
      align: "center",
      flex: 0.4,

      renderCell: (value) => (
        <Avatar variant="circular" className={classes.Avatar}>
          {value.value}
        </Avatar>
      ),
    },

    {
      field: "order_date",
      headerName: "زمان سفارش",
      headerAlign: "center",
      align: "center",
      width: 180,

      renderCell: (value) => {
        return (
          <Grid item className={classes.TableCell} style={{ width: 150 }}>
            <Grid container justifyContent="flex-start" item xs={5}>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_weekday}
              </Typography>
            </Grid>
            <Grid container justifyContent="flex-end" item xs={7}>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_date}
              </Typography>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_time}
              </Typography>
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: "delivery_date",
      headerName: "زمان ارسال",
      headerAlign: "center",
      align: "center",
      width: 180,

      renderCell: (value) => {
        return (
          <>
            {!value.row.immediate_delivery ? (
              <Grid className={classes.TableCell}>
                <Grid container justifyContent="center" item xs={4}>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_weekday}
                  </Typography>
                </Grid>
                <Grid container justifyContent="center" item xs={8}>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_date}
                  </Typography>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_start_time + " "}-
                    {" " + value.row.delivery_end_time}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="center" alignItems="center">
                <Typography variant="h5" style={{ color: "#da5c87" }}>
                  فوری
                </Typography>
              </Grid>
            )}
          </>
        );
      },
    },

    {
      field: "state",
      headerName: "وضعیت",
      headerAlign: "center",
      align: "center",
      flex: 0.6,

      renderCell: (value) => {
        return (
          <Typography
            color="textSecondary"
            className={classes.stateColumn}
            style={{
              backgroundColor:
                value.value === "در حال چاپ"
                  ? "#3914FE"
                  : value.value === "پرداخت تایید شد"
                  ? "#55C21E"
                  : value.value === "لغو شده"
                  ? "#FE8B00"
                  : value.value === "تحویل شد"
                  ? "#3B8815"
                  : value.value === "ارجاع از دفتر"
                  ? "#FE0000"
                  : value.value === "آماده ارسال"
                  ? "#1E91C2"
                  : value.value === "ارسال شد"
                  ? "#00B341"
                  : value.value === "ثبت شد"
                  ? "#53CB16"
                  : value.value === "سفارش ثبت شد"
                  ? "#E30000"
                  : "blue",
            }}
            variant="subtitle2"
          >
            {value.value}
          </Typography>
        );
      },
    },
    {
      field: "id",
      headerName: "مشاهده",
      headerAlign: "center",
      align: "center",
      flex: 0.4,

      renderCell: (value) => {
        return (
          <OrderDetails
            rowValue={value.row.number}
            orderId={value.value}
            position="visibility"
          />
        );
      },
    },
  ];

  return (
    <DataGrid
      columns={customer_header_list}
      rows={orders}
      loading={loading}
      sortingOrder={["desc", "asc"]}
      disableSelectionOnClick
      disableColumnFilter
      getRowClassName={(props) => {
        if (props.row.immediate_delivery || props.row.lated) {
          return "test";
        }
      }}
      disableColumnMenu
      hideFooter
      pageSize={orders.length}
      components={{
        NoRowsOverlay: NoRowsMessage,
        LoadingOverlay: CustomLoading,
      }}
    />
  );
};

const mapToStateProps = (props) => {
  const { OrderReducer, searchReducer } = props;

  const { activeOrders, loading, refresh, currentOrder } = OrderReducer;

  return { activeOrders, loading, searchReducer, refresh, currentOrder };
};

export default connect(mapToStateProps)(OrdersTable);
